
export const examData = (data: any[]): any[] => {
  data.map((item: object) => {
    item.option = item.optionVos
    item.title = item.content
  })
  return data
}
